import { useEffect, useCallback, useState, useContext, createContext } from 'react'
import { useSelector } from 'react-redux'
// import { useAuth } from '../../../../../../context/AuthContext'
import { toast } from 'react-toastify'
import moment from 'moment'
import { api } from '../../../../../../services/api'

export const ProductsDetailedContext = createContext();


export function ProductsDetailedProvider({ children }){
    const productsDatas = useSelector(state => state.modalCentralized.datasComponent)
    //const { signOut } = useAuth()
    const [isLoading, setIsLoading] = useState(true)
    const [loadingButton, setLoadingButton] = useState(false)
    const [allProductsDatas, setAllProductsDatas] = useState({})
    const [page,setPage] = useState(1);
    const [totalProducts,setTotalProducts] = useState('');
    const [totalDelivery,setTotalDelivery] = useState('');
    const [totalDescont,setTotalDescont] = useState('');


    let dateToCsvDownload = `Produtos_${moment(productsDatas.startDate).format('DD-MM-YYYY-HH:mm')}ate${moment(productsDatas.endDate).format('DD-MM-YYYY-HH:mm')}`

    const fetchData = useCallback(async () => {
        setLoadingButton(true)
        try{
           const response = await api.post(`/getResumeProductsNew?page=${page}`,{
                data:{
                    business:  productsDatas.business,
                    endDate:  productsDatas.endDate,
                    salesChannels:  productsDatas.salesChannels,
                    startDate:  productsDatas.startDate,
                    type: 'normal'
                }
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('@Inoveclube:token')
                }
            })
            //console.log(response)
            const data = handleData(response.data.datas)
            setAllProductsDatas([...allProductsDatas, ...data])
            setPage(response.data.next_page)
            setLoadingButton(false);
        }
        catch(error){
            toast.error('Ops, algo deu errado')
            setLoadingButton(false);
        }   
        
    }, [page, productsDatas, allProductsDatas])



    useEffect(() => {
        async function loadProducts(){
            try{
                //console.log(productsDatas)
                const response = await api.post('/getResumeProductsNew?page=1',
                {
                    data:{
                        business:  productsDatas.business,
                        endDate:  productsDatas.endDate,
                        salesChannels:  productsDatas.salesChannels,
                        startDate:  productsDatas.startDate,
                        type: 'normal'
                    }
                }
                , {
                    headers: {
                        'Content-Type': 'application/json',
                        token: localStorage.getItem('@Inoveclube:token')
                    }
                })
                const {datas,next_page,total} = response.data;
                setAllProductsDatas(handleData(datas))
                setPage(next_page)
                
                setTotalDescont(total.descontoVenda);
                setTotalDelivery(total.vlTaxaEntrega);
                setTotalProducts(total.vlValor);

                setIsLoading(false)
            }
            catch(error){
                toast.error('Ops, algo deu errado')
            }
        }
        loadProducts()
    }, [productsDatas])

    const handleData = (data) => {
        const result = Object.entries(data.reduce((acc, {cdGrupo, cdProduto, descont, dsGrupo, dsProduto, nrQtd, preco, total, delivery}) => {
            acc[dsGrupo] = (acc[dsGrupo] || []);
            acc[dsGrupo].push({
                cdGrupo, 
                cdProduto, 
                descont, 
                dsProduto, 
                nrQtd, 
                preco, 
                total,
                delivery
            });
            return acc;
        },{}))
        .map(([key, value]) => ({name: key, children: value}));
        return result
    }    


    return(
        <ProductsDetailedContext.Provider 
            value={ { 
                isLoading,
                setIsLoading,
                allProductsDatas,
                dateToCsvDownload,
                page,
                fetchData,
                loadingButton,
                totalDelivery,
                totalDescont,
                totalProducts
            } }
        >
            { children }
        </ProductsDetailedContext.Provider>
    )
    }



export function useProductsDetailed() {
   const context = useContext(ProductsDetailedContext)

   if(!context) {
    throw new Error('useProductsDetailed must be used within an Provider');
  } 

   return context
}
